<template>
  <b-container fluid class="no-padding">
    <b-row class="my-1 stencilform">

      <b-col lg="7" sm="12" class="stencilform-previews no-padding" id="stencilform-previews">
        <preview-form></preview-form>
      </b-col>

      <b-col lg="5" class="stencilform-tools no-padding">
        <b-tabs card vertical
                nav-class = "stencilform-tools-wrapper-nav"
                nav-wrapper-class = "stencilform-tools-wrapper"
                :stencileaseTab="stencileaseTab"
                @input="catchClicked"
                v-model="stencileaseTabs">
          <b-tab title-item-class="stencilform-tools-wrapper-nav-item"
            :active="activeStatus[0]"
            :disabled="disabledStatus[0]">

            <template slot="title">
              <div>
                <div>
                  <div>
                    <i class="fa fa-font"></i><span>font</span>
                  </div>
                </div>
              </div>
            </template>

            <step-font></step-font>
          </b-tab>

          <b-tab title-item-class="stencilform-tools-wrapper-nav-item"
                  :active="activeStatus[1]"
                  :disabled="disabledStatus[1]">
            <template slot="title">
            <div><div><div><i class="fa fa-text-height"></i><span>height</span></div></div></div>
            </template>
            <step-height></step-height>
          </b-tab>

          <b-tab title-item-class="stencilform-tools-wrapper-nav-item"
                 :active="activeStatus[2]"
                 :disabled="disabledStatus[2]">
            <template slot="title">
              <div><div><div><i class="fa fa-building"></i><span>material</span></div></div></div>
            </template>
            <step-material></step-material>
          </b-tab>

          <b-tab title-item-class="stencilform-tools-wrapper-nav-item"
            :active="activeStatus[3]"
            :disabled="disabledStatus[3]">
            <template slot="title">
              <div><div><div><i class="fa fa-plus"></i><span>quantity</span></div></div></div>
            </template>
            <step-quantity></step-quantity>
          </b-tab>
        </b-tabs>
      </b-col>

    </b-row>
  </b-container>

</template>

<script>
import jQuery from 'jquery'

import previewForm from './stencilease-lc-preview.vue'
import stepFont from './stencilease-lc-step-font.vue'
import stepHeight from './stencilease-lc-step-height.vue'
import stepMaterial from './stencilease-lc-step-material.vue'
import stepQuantity from './stencilease-lc-step-quantity.vue'

export default {
  components: {
    jQuery,
    previewForm,
    stepFont,
    stepHeight,
    stepMaterial,
    stepQuantity
  },
  data() {
    return {
      stencileaseTabs: 0,
      // activeStatus: [true, false, false, false],
      // disabledStatus: [false, true, true, true],
      activeStatus: [true, true, true, true],
      disabledStatus: [false, false, false, false],
      intervalVar: null
    }
  },
  computed: {
    stencileaseTab: {
      get: function () {
        let activeTab = this.$store.state.product.activeTab
        this.disabledStatus[activeTab] = false
        for(let i in this.activeStatus) {
          if (i < activeTab) {
            this.activeStatus[i] = true
          } else if(i == activeTab) {
            this.activeStatus[i] = true
          } else {
            this.activeStatus[i] = true
          }
        }

        this.stencileaseTabs = activeTab

        let obj = this
        this.intervalVar = setTimeout(function(){
          obj.stencileaseTabs = activeTab
        }, 50);

        return this.$store.state.product.activeTab
      }
    }
  },
  methods: {
    catchClicked(index) {
      if (index == 3) {
        jQuery('.stencilform-lc-wrapper input').show()
      } else {
        jQuery('.stencilform-lc-wrapper input').hide()
      }
    }
  }
}
</script>
